import React, { Component } from 'react';
import web3 from "./web3";
import './App.css';
import vote from './vote';
import Vote from './components/Votes/Vote/Vote';
import Loader from './components/Loader1/Loader'
import Nav from './components/Navbar/Nav';
import Button from './components/Button/Button';
import Aux from "./Aux/Aux";
class App extends Component {
  state = {
    account: "",
    elections: [],
    load:false,
    candidates: ["",""],
    scroll:false,
    error:null
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll = event => {
    
    if (window.pageYOffset > 50 && !this.state.scroll) {
      this.setState({
        scroll: true,
      });
    }
    if (window.pageYOffset <= 50 && this.state.scroll) {
      this.setState({
        scroll: false
      });
    }
  }
  async componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    if(web3 === "undefined"){
      this.setState({
        error:"Metamask Not Installed ! Add it as a Plugin.."
      })
      return;
    }
    this.setState({
      load:true
    })
    const accounts = await web3.eth.getAccounts();

    const elections = await vote.methods.getAllElections().call();
    this.setState({
      elections: elections[0],
      account: accounts[0],
      load:false
    })
  }
  createElection = async (e) => {
    e.preventDefault();
    this.setState({
      load:true
    })
    const arr = this.state.candidates.map(candidate => (web3.utils.fromAscii(candidate)));


    await vote.methods.createNewElection(arr).send({ from: this.state.account })
    const elections = await vote.methods.getAllElections().call();
    this.setState({
      elections: elections[0],
      candidates: ["", ""],
      load:false
    })
  }

  addCandidate = () => {
    this.setState({
      candidates: [...this.state.candidates, ""]
    })
  }
  render() {
    let load = ("");
    if(this.state.error){
      return (
        <div className="App">
          {this.state.error}<br /><br />
          Sorry for inconvenience !<br /><br />
          Visit again <br /><br />
          Made By Amit Chambial
        </div>
      )
    }
    if(this.state.load){
      load=<Loader/>;
    }
    return (<Aux>
      <Nav scroll={this.state.scroll}/>
      <div className="App">
      {load}
        <ul className="votes">
          {this.state.elections.map((election, i) => {
            return (<Vote index={i} key={i} creator={election} account={this.state.account}/>);
          })}
        </ul>
        <div className="addCandidate">
        <h2>Create A New Election</h2>
          <form onSubmit={this.createElection} >
            {this.state.candidates.map((candidate, i) => {
              return ([<input  type="text" name={"candidate_" + i} placeholder={"Candidate " + (i+1)} onChange={(e) => this.setState({
                candidates: this.state.candidates.map((candidate, i) => {
                  if (i === parseInt(e.target.name.split("_")[1],10)) {
                    return e.target.value
                  }
                  else {
                    return candidate;
                  }
                })
              })} value={candidate} key={i} required />, <br key={Math.random()}/>])
            })}
          <Button onClick={this.addCandidate} style={{ backgroundColor: "orange" }} attr={{type:"button"}}>Add Candidate</Button><br/>
            <Button style={{backgroundColor:"orange"}}>Create</Button>
          </form>
        </div>
        Made By Amit Chambial
      </div>
    </Aux>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js